export default "__VITE_ASSET__DVPxynbC__"